import { FormikProps } from "formik";
import { PublisherFormValues } from "../utils/types";

interface PublisherSwitchesProps {
  formikProps: FormikProps<PublisherFormValues>;
}

const PublisherSwitches = ({ formikProps }: PublisherSwitchesProps) => {
  void formikProps; // Mark as intentionally unused
  return null;
};

export default PublisherSwitches;
